import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFichaResumen } from 'src/app/models/IFichaResumen';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { URL_API } from 'src/app/global/config';
import * as printJS from 'print-js';
// import printJS = require("print-js");


@Component({
  selector: 'app-ModalResumenFicha',
  templateUrl: './ModalResumenFicha.component.html',
  styleUrls: ['./ModalResumenFicha.component.css']
})
export class ModalResumenFichaComponent implements OnInit {

  urlServidorPublico: string = URL_API.UrlServidorPubico

  @Input() ficha: IFichaResumen

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    //this.ficha = null;
    console.log('modal:',this.ficha)
  }

  openPDF() {
    printJS({
      printable: 'htmlData',
      type: 'html',
      targetStyles:['*']
    })

  }


  // public openPDF():void {
  //   const DATA = document.getElementById('htmlData');
  //   const doc = new jsPDF('p', 'pt', 'a4');
  //   const options = {
  //     background: 'white',
  //     scale: 3
  //   };
  //   html2canvas(DATA, options).then((canvas) => {

  //     const img = canvas.toDataURL('image/PNG');

  //     // Add image Canvas to PDF
  //     const bufferX = 15;
  //     const bufferY = 15;
  //     const imgProps = (doc as any).getImageProperties(img);
  //     const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     doc.addImage(img, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
  //     return doc;
  //   }).then((docResult) => {
  //     docResult.save(`${new Date().toISOString()}_tutorial.pdf`);
  //   });
  // }
}
